import { render, staticRenderFns } from "./ListDashboardPage.vue?vue&type=template&id=237dbf31"
import script from "./ListDashboardPage.vue?vue&type=script&lang=js"
export * from "./ListDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports